<template>
  <div class="rootDom">
    <div class="titleGrid">
      <div class="close-btn" @click="hide('Close')">
        <i class="icon-popup-close"></i>
      </div>
    </div>

    <div class="content">配音仍未完成,是否要结束编辑?</div>
    <div class="btnGrid">
      <div class="grayBtn" @click="hide('Cancel')">取消</div>
      <div class="buleBtn" @click="hide('Ok')">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "useConfirmationDialog",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    hide(type) {
      this.$emit("resultHandler", { type: type });
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
@import "./commonStyle";
.rootDom {
  position: relative;
  width: 540px;
  height: 234px;
  margin: auto;
  background-color: #ffffff;
  border-radius: 4px;

  .titleGrid {
    position: absolute;
    width: 100%;
    position: relative;
    height: 40px;

    .close-btn {
      position: absolute;
      top: 14px;
      right: 17px;
      cursor: pointer;
    }
  }

  .content {
    position: absolute;
    top: 72px;
    width: 100%;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
  }
  .btnGrid {
    position: absolute;
    margin: 0 auto;
    top: 120px;
    width: 100%;
    padding: 0 87px;
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/closeSmartVoiceDialog.vue